
// SVG Icon: search
export default { id: "terriajs-search" };
export const id = "terriajs-search";
export const name = "search";
